/**
 * ID20 — 송장 일괄등록 FE 타입. (be-order 계약 — 도착 시 정합.)
 * 배송대기 주문을 Excel 로 다운로드 → 송장 기입 → 업로드 → 배송중/배송완료 자동 전환.
 */

/** 공급사 스코프. ALL=전체, HQ=본사 직배송, VENDOR=입점사. */
export type SupplierScope = 'ALL' | 'HQ' | 'VENDOR';

export const SUPPLIER_SCOPES: ReadonlyArray<SupplierScope> = ['ALL', 'HQ', 'VENDOR'];

export const SUPPLIER_SCOPE_LABELS: Record<SupplierScope, string> = {
  ALL: '전체',
  HQ: '본사',
  VENDOR: '입점사',
};

/** 일괄등록 잡 상태. be-order: COMPLETED(전건성공)|PARTIAL(일부실패)|FAILED(전건실패). */
export type BulkJobStatus = 'COMPLETED' | 'PARTIAL' | 'FAILED';

export const BULK_JOB_STATUSES: ReadonlyArray<BulkJobStatus> = ['COMPLETED', 'PARTIAL', 'FAILED'];

export const BULK_JOB_STATUS_LABELS: Record<BulkJobStatus, string> = {
  COMPLETED: '완료',
  PARTIAL: '일부 실패',
  FAILED: '실패',
};

/** 행 처리 결과. */
export type BulkRowResult = 'SUCCESS' | 'FAIL';

/** GET /admin/v1/orders/invoice-bulk/jobs 목록 항목 (InvoiceBulkJobResponse). */
export interface InvoiceBulkJob {
  jobId: string;
  uploadedBy: string | null;
  supplierScope: SupplierScope;
  /** 업로드 시 적용한 공급사 검색어(선택). */
  supplierKeyword: string | null;
  fileName: string;
  totalCount: number;
  successCount: number;
  failCount: number;
  /** 송장은 등록됐으나 상태 전환에 실패한 건수. */
  statusChangeFailCount: number;
  status: BulkJobStatus;
  createdAt: string;
}

/** 잡 상세/업로드 응답의 개별 행 (InvoiceBulkJobRow). */
export interface InvoiceBulkJobRow {
  rowNo: number;
  orderNo: string;
  productOrderNo: string | null;
  courierCode: string | null;
  trackingNo: string | null;
  shippedDate: string | null;
  deliveredDate: string | null;
  result: BulkRowResult;
  failReason: string | null;
}

/** GET /admin/v1/orders/invoice-bulk/jobs/{id} 응답 — job + rows 중첩. */
export interface InvoiceBulkJobDetail {
  job: InvoiceBulkJob;
  rows: ReadonlyArray<InvoiceBulkJobRow>;
}

/** POST /admin/v1/orders/invoice-bulk 응답 = 등록 잡 요약 + 실패행. */
export interface InvoiceBulkUploadResult {
  jobId: string;
  fileName: string;
  totalCount: number;
  successCount: number;
  failCount: number;
  statusChangeFailCount: number;
  status: BulkJobStatus;
  /** 실패한 행만(성공행 제외). 즉시 사유 표시용. */
  failedRows: ReadonlyArray<InvoiceBulkJobRow>;
  createdAt: string;
}

/** 잡 목록 검색 필터. */
export interface InvoiceBulkJobFilter {
  supplierScope: SupplierScope | '';
  keyword: string;
  status: BulkJobStatus | '';
  dateFrom: string;
  dateTo: string;
}

/** 택배사 마스터 항목 (GET /admin/v1/orders/invoice-bulk/couriers data.items[]). */
export interface CourierCompany {
  courierCode: string;
  nameKo: string;
  nameEn: string | null;
  active: boolean;
  sortOrder: number;
}
